<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">C<span class="small">ONTENTS</span></p>
<p class="toc3"><a href="#/Acknowledgements">Acknowledgements</a></p>
<p class="toc2"><a href="#/Introduction">Introduction</a></p>
<p class="toc3"><a href="#/Chapter1">1. Do They Know It’s Christmas?</a></p>
<p class="toc2"><span href="#/Chapter2" title="Link target outside of Sample">2. An Audience with the Pope</span></p>
<p class="toc2"><span href="#/Chapter3" title="Link target outside of Sample">3. Night Shift</span></p>
<p class="toc2"><span href="#/Chapter4" title="Link target outside of Sample">4. Burn, Baby, Burn</span></p>
<p class="toc2"><span href="#/Chapter5" title="Link target outside of Sample">5. Fugitives to Freedom</span></p>
<p class="toc2"><span href="#/Chapter6" title="Link target outside of Sample">6. Photogenic Phantasms</span></p>
<p class="toc2"><span href="#/Chapter7" title="Link target outside of Sample">7. The Boy Torturer</span></p>
<p class="toc2"><span href="#/Chapter8" title="Link target outside of Sample">8. Smallpox Smackdown</span></p>
<p class="toc2"><span href="#/Chapter9" title="Link target outside of Sample">9. The Suitcase Case</span></p>
<p class="toc2"><span href="#/Chapter10" title="Link target outside of Sample">10. Murder at the Y</span></p>
<p class="toc2"><span href="#/Chapter11" title="Link target outside of Sample">11. Nevertheless, He Persisted</span></p>
<p class="toc2"><span href="#/Chapter12" title="Link target outside of Sample">12. Fatal Plunge</span></p>
<p class="toc2"><span href="#/Chapter13" title="Link target outside of Sample">13. Nightclub Nightmare</span></p>
<p class="toc2"><span href="#/Chapter14" title="Link target outside of Sample">14. Soaring Social Worker</span></p>
<p class="toc2"><span href="#/Chapter15" title="Link target outside of Sample">15. Monkeys and Cobras and Bears, Oh My!</span></p>
<p class="toc2"><span href="#/Chapter16" title="Link target outside of Sample">16. Jew Hunting</span></p>
<p class="toc2"><span href="#/Chapter17" title="Link target outside of Sample">17. The Tyler Street Massacre</span></p>
<p class="toc3"><span href="#/Bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc2"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?3b43c4fc